import clsx from 'clsx'
import { Document, FileAlert, FileImage, FilePaper, FilePdf, Template } from '@/assets/icons'

/** File-type icon variants */
type FileTypeVariant = 'pdf' | 'word' | 'template' | 'image' | 'generic'

const PDF_EXTENSIONS = ['pdf']
const WORD_EXTENSIONS = ['doc', 'docx']
const TEMPLATE_EXTENSIONS = ['dot', 'dotx', 'pot', 'potx', 'xlt', 'xltx', 'ott', 'otp', 'otg']
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'tiff', 'tif']

function getFileExtension(filename: string): string {
  const lower = filename.toLowerCase()
  const dot = lower.lastIndexOf('.')
  if (dot < 0 || dot === lower.length - 1) return ''
  return lower.slice(dot + 1)
}

function getFileTypeVariant(extension: string): FileTypeVariant {
  if (PDF_EXTENSIONS.includes(extension)) return 'pdf'
  if (WORD_EXTENSIONS.includes(extension)) return 'word'
  if (TEMPLATE_EXTENSIONS.includes(extension)) return 'template'
  if (IMAGE_EXTENSIONS.includes(extension)) return 'image'
  return 'generic'
}

export function UploadCardFileIcon({ filename, error }: { filename: string; error?: boolean }) {
  const extension = getFileExtension(filename)
  const variant = getFileTypeVariant(extension)

  const Icon = error
    ? FileAlert
    : variant === 'pdf'
    ? FilePdf
    : variant === 'word'
    ? Document
    : variant === 'template'
    ? Template
    : variant === 'image'
    ? FileImage
    : FilePaper

  return <Icon className={clsx('shrink-0 w-6 h-6', error ? 'text-red-800' : 'text-text-secondary')} aria-hidden />
}
